import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.css";
import Modal from "react-bootstrap/Modal";
import { customName, getColorFromId } from "../../helpers/commonHelpers";
import { useSelector, useDispatch } from "react-redux";
import {
  getAgendaWithMinutesDetails,
  giveMomWritePermission,
} from "../../redux/actions/meetingActions/MeetingAction";
import LoaderButton from "../Common/LoaderButton";
import SmallLoaderButton from "../Common/SmallLoaderButton";

const AttendeesModal = React.memo((props) => {
  const dispatch = useDispatch();
  const employeeData = useSelector((state) => state.user);
  const meetingDetails = useSelector((state) => state.meeting);
  const accessToken = localStorage.getItem("accessToken");
  const { attendees, meetingData, attendeeType } = props;
  const [attendeesArray, setAttendeesArray] = useState([]);
  const [formData, setFormData] = useState({
    fromTime: "",
    toTime: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    setAttendeesArray(attendees);
    setFormData({
      ...formData,
      fromTime: meetingData?.actualFromTime,
      toTime: meetingData?.actualToTime,
    });
    if (meetingDetails.isAttendanceStatus && accessToken) {
      dispatch(getAgendaWithMinutesDetails(meetingData._id, accessToken));
    }
  }, [
    props.isAttendace,
    props.IsModalOpen,
    meetingDetails.isAttendanceStatus,
    meetingDetails.loading,
  ]);

  const checkMomWritePermissionHandler = (e, attendeeId) => {
    const { checked } = e.target;

    if (attendeeId) {
      const modifiedAttendees = attendeesArray.map((obj) => {
        if (obj._id === attendeeId) {
          return { ...obj, canWriteMOM: checked };
        }
        return obj;
      });

      setAttendeesArray(modifiedAttendees);
    }
  };

  const submitMomWritePermission = async () => {
    const payload = {
      attendees: attendeesArray.map(
        ({
          name,
          email,
          isEmployee,
          empId,
          designation,
          companyName,
          isMeetingOrganiser,
          isAdmin,
          role,
          department,
          ...keepAttrs
        }) => keepAttrs
      ),
    };
    setIsLoading(true);
    const result = await dispatch(
      giveMomWritePermission(meetingData?._id, payload, accessToken)
    );
    setIsLoading(false);
    if (result?.status) {
      props.setIsModalOpen(false);
      props.closeMomPermissionModalClose();
    }
  };

  if (attendeeType === "guests") {
    const attendeesArrayFilter = attendeesArray.filter(
      (attendeeType) => attendeeType.isEmployee === false
    );
    setAttendeesArray(attendeesArrayFilter);
  }

  if (attendeeType === "attendees") {
    const attendeesArrayFilter = attendeesArray.filter(
      (attendeeType) => attendeeType.isEmployee === true
    );
    setAttendeesArray(attendeesArrayFilter);
  }

  return (
    <>
      <Modal
        show={props.IsModalOpen}
        onHide={(e) => props.setIsModalOpen(false)}
        backdrop="static"
      >
        <div className="modal-header attendees-modal">
          <div>
            <h4 className="modal-title">Attendee(s)</h4>
          </div>

          <div>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={(e) => props.setIsModalOpen(false)}
            ></button>
          </div>
        </div>

        <Modal.Body className="modal-height meetings-modal-attendees-list">
          <div className="attendees-popup">
            {attendeesArray &&
              attendeesArray.map((attendee, index) => {
                return (
                  <div className="attendee-content" key={index}>
                    {props.loginUserData?.userData?.isMeetingOrganiser ||
                      props.loginUserData?.userData?.isAdmin ? (
                      <div className="check-attendee">
                        {props.isShow &&
                          (meetingData?.meetingStatus?.status === "scheduled" ||
                            meetingData?.meetingStatus?.status ===
                            "rescheduled" ||
                          meetingData?.meetingStatus?.status === "draft" && meetingData?.isActive) ? (
                          <input
                            type="checkbox"
                            name="updateAttendance"
                            id=""
                            className="form-check-input"
                            onChange={(e) =>
                              checkMomWritePermissionHandler(e, attendee._id)
                            }
                            disabled={
                              employeeData.userData?.isAdmin === true
                                ? false
                                : employeeData.userData._id.toString() ===
                                  props?.meetingData?.createdById?.toString()
                                  ? false
                                  : true
                            }
                            checked={
                              attendee?.isAdmin === true ||
                                (attendee?._id?.toString() ===
                                  employeeData.userData._id.toString() &&
                                  employeeData.userData.isAdmin === true) ||
                                attendee?._id?.toString() ===
                                props?.meetingData?.createdById?.toString()
                                ? true
                                : attendee.canWriteMOM
                            }
                          />
                        ) : null}

                        <div
                          className="attendee1 attendee-list sl ml-0 attendee-list-circle"
                          style={{
                            backgroundColor: attendee?.profilePicture ? undefined : getColorFromId(attendee?._id),
                            // borderRadius: "50px",
                            // padding: "4px 8px",
                            // color: "#fff",
                            // display: "flex",
                            // alignItems: "center",
                            // justifyContent: "center",
                            // minWidth: "35px",
                            // height: "35px",
                          }}
                        >
                          {attendee?.profilePicture ? (
                            <img
                              src={`${process.env.REACT_APP_API_URL}${attendee.profilePicture}`}
                              alt=""
                              className="attendee-profile-picture icon-image attendee-list-circle-img"
                              style={{
                                // width: "35px",
                                // height: "35px",
                                // borderRadius: "50%",
                                // objectFit: "cover",
                              }}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.style.display = "none";
                                // e.target.parentElement.innerHTML = `<span class="attendee-name">${customName(
                                //   attendee?.name
                                // )}</span>`;
                                // e.target.parentElement.style.backgroundColor = getColorFromId(attendee?._id);
                                 e.target.parentElement.style.backgroundColor = getColorFromId(
                                attendee?._id
                              );
                              e.target.parentElement.innerText = customName(
                                attendee?.name
                              );
                              }}
                            />
                          ) : (
                            customName(attendee.name)
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="attendee-content" key={index}>
                        <div
                          className="attendee1 attendee-list sl ml-0"
                          style={{
                            backgroundColor: attendee?.profilePicture ? undefined : getColorFromId(attendee?._id),
                            borderRadius: "50px",                           
                            color: "#fff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            minWidth: "35px",
                            height: "35px",
                          }}
                        >
                          {attendee?.profilePicture ? (
                            <img
                              src={`${process.env.REACT_APP_API_URL}${attendee.profilePicture}`}
                              alt=""
                              className="attendee-profile-picture icon-image"
                              style={{
                                width: "35px",
                                height: "35px",
                                borderRadius: "50%",
                                objectFit: "cover",
                              }}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.style.display = "none";
                                e.target.parentElement.innerHTML = `<span class="attendee-name">${customName(attendee?.name)}</span>`;
                                // e.target.parentElement.style.backgroundColor = getColorFromId(attendee?._id);
                              }}
                            />
                          ) : (
                            customName(attendee.name)
                          )}
                        </div>
                      </div>
                    )}

                    <div className="action-cmnt-text">
                      <p className="detail-name word-break">
                        {" "}
                        {attendee?._id?.toString() ===
                          props?.meetingData?.createdById?.toString()
                          ? attendee.name + " (Organiser)"
                          : attendee.isAdmin === true
                            ? attendee.name + " (Admin)"
                            : attendee.name}
                      </p>

                      {attendee?._id?.toString() ===
                        props?.meetingData?.createdById?.toString() &&
                        employeeData.userData.isAdmin === true ? (
                        <p className="name-undertext detail-date-time comment-text word-break">
                          {attendee.email}
                        </p>
                      ) : (
                        <>
                          {attendeeType && attendeeType == "attendees" ? (
                            <p className="name-undertext detail-date-time comment-text word-break">
                              {attendee.email}{" "}
                              {attendee.empId
                                ? " (" + attendee.empId + ") "
                                : ""}
                            </p>
                          ) : attendeeType && attendeeType == "guests" ? (
                            <p className="name-undertext detail-date-time comment-text word-break">
                              {attendee.email}{" "}
                              {attendee.empId
                                ? " (" + attendee.empId + ") "
                                : ""}
                            </p>
                          ) : (
                            <>
                              <p className="name-undertext detail-date-time  comment-text word-break">
                                {attendee.email}{" "}
                                {attendee.empId
                                  ? " (" + attendee.empId + ") "
                                  : " (Guest) "}
                              </p>
                              {attendee?.designation ? (
                                <div className="detail-date-time mt-1 des-comp">
                                  <span> Designation -</span>{" "}
                                  {attendee.designation}
                                </div>
                              ) : null}
                              {attendee?.role ? (
                                <div className="detail-date-time mt-1 des-comp">
                                  <span> Role -</span> {attendee.role}
                                </div>
                              ) : null}
                              {attendee?.department ? (
                                <div className="detail-date-time mt-1 des-comp">
                                  <span> Department -</span>{" "}
                                  {attendee.department}
                                </div>
                              ) : null}
                              {attendee?.companyName ? (
                                <div className="detail-date-time des-comp">
                                  <span> Company Name -</span>{" "}
                                  {attendee.companyName}
                                </div>
                              ) : null}
                            </>
                          )}
                        </>
                      )}

                      {props.isShow &&
                      (attendee?._id?.toString() ===
                        props?.meetingData?.createdById?.toString() ||
                        attendee?.isAdmin === true ||
                        attendee.canWriteMOM) &&
                      (meetingData?.meetingStatus?.status === "scheduled" ||
                        meetingData?.meetingStatus?.status === "rescheduled" ||
                        meetingData?.meetingStatus?.status === "draft" && meetingData?.isActive) ? (
                        <span className="permission">
                          With MOM write permission
                        </span>
                      ) : null}
                    </div>
                  </div>
                );
              })}
          </div>
        </Modal.Body>

        <div className="">
          {!props.isAttendace &&
          (props?.meetingData?.createdById?.toString() ===
            employeeData?.userData?._id?.toString() ||
            employeeData.userData.isAdmin === true) &&
          (meetingData?.meetingStatus?.status === "scheduled" ||
            meetingData?.meetingStatus?.status === "rescheduled" ||
            meetingData?.meetingStatus?.status === "draft" && meetingData?.isActive) ? (
            <Modal.Footer>
              {isLoading ? (
                <div className="meeting-page " style={{ textAlign: "center" }}>
                  <SmallLoaderButton />
                </div>
              ) : (
                <button
                  type="button"
                  className="Mom-btn btn btn-secondary bg-primary border-primary"
                  onClick={submitMomWritePermission}
                >
                  <p>Set MOM Write Permission</p>
                </button>
              )}
            </Modal.Footer>
          ) : null}
        </div>
      </Modal>
    </>
  );
});

export default AttendeesModal;
